import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Industries from 'components/industries';

type Props = {
  data: Object,
};

const IndustriesPage = ({ data }: Props) => {
  const {
    industriesJson,
    getInTouchJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...industriesJson,
        getInTouch: getInTouchJson,
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <Industries />
      </Layout>
    </Website>
  );
};

export default IndustriesPage;

export const query = graphql`
  query IndustriesPageQuery {
    industriesJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      cases {
        cards {
          id
          title
          content
          list {
            title
            items
          }
          image
        }
      }
      meta {
        description
        title
      }
    }
    getInTouchJson {
      ...GetInTouchJsonFragment
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
